<template>
  <el-table-column
    :label="value"
    :sortable="sortable || false"
    :sort-orders="sortOrders"
    :fixed="fixed || false"
    :align="align"
    :width="widthBackup"
    :prop="sortable ? (sortField || field) : ''"
    type="isNotSummary"
    :class-name="headerClassName"
  >
    <template v-slot="{ row }">
      <template v-if="timeFormat === 'timeAgoWithYmdHi'">{{ row[field] | timeAgoWithYmdHi(emptyTip) }}</template>
      <template v-if="timeFormat === 'timeToYmdHi'">{{ row[field] | timeToYmdHi(emptyTip) }}</template>
      <template v-if="timeFormat === 'timeToYmd'">{{ row[field] | timeToYmd(emptyTip) }}</template>
      <template v-if="timeFormat === 'timeToYm'">{{ row[field] | timeToYm(emptyTip) }}</template>
    </template>
  </el-table-column>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '添加时间',
    },
    field: {
      type: String,
      default: 'add_time',
    },
    sortField: {
      type: String,
      default: '',
    },
    sortable: {
      type: String,
      default: 'custom',
    },
    fixed: String,
    timeFormat: {
      type: String,
      default: 'timeToYmdHi',
    },
    emptyTip: {
      type: String,
      default: '-',
    },
    align: {
      type: String,
      default: '',
    },
  },
  computed: {
    routeQuery() {
      return this.$route.query || {};
    },
    orderBy() {
      return this.routeQuery.order_by || '';
    },
    isAsc() {
      return parseInt(this.routeQuery.is_asc) || 0;
    },
    effectiveSortField() {
      return this.sortField || this.field;
    },
    isCurrentSortColumn() {
      if (!this.sortable) return false;
      return !this.orderBy || (this.orderBy === this.effectiveSortField);
    },
    sortDirection() {
      if (!this.isCurrentSortColumn) return '';
      return this.isAsc === 1 ? 'ascending' : 'descending';
    },
    headerClassName() {
      return this.isCurrentSortColumn ? this.sortDirection : '';
    },
  },
  data: () => ({
    widthBackup: '',
    sortOrders: ['descending', 'ascending'],
  }),
  beforeMount() {
    if (this.isAsc) this.sortOrders = ['ascending', 'descending'];
    if (this.timeFormat === 'timeAgoWithYmdHi') return this.widthBackup = '180';
    if (this.timeFormat === 'timeToYmdHi') return this.widthBackup = '145';
    if (this.timeFormat === 'timeToYmd') return this.widthBackup = '120';
    if (this.timeFormat === 'timeToYm') return this.widthBackup = '100';
  },
};
</script>
